import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { GlobalErrorBoundary } from '@/shared/components/feedback/global-error-boundary';
import { router } from '@/routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attempt) => {
        const cap = 30_000;
        const base = Math.min(1000 * 2 ** attempt, cap);
        return base * (0.8 + 0.2 * Math.random());
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});

export function App() {
  return (
    <GlobalErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton />
      </QueryClientProvider>
    </GlobalErrorBoundary>
  );
}
